import { firestoreAction } from 'vuexfire'
import { db, increment } from '@/plugins/firebase'
import { ga } from '@/main'

const PAGE_SIZE = 10;
const state = {
    questions: {},
    myQuestions: [],
    tags: [],
    order: "",
    author: "",
}

const mutations = {
    REFRESH_QUESTIONS: function (state) {
        state.questions = { ...state.questions };
    },
    RESET_QUESTIONS: function (state) {
        state.questions = {};
    },
    SET_TAGS: function (state, tags) {
        state.tags = [...tags]
    },
    SET_ORDER: function (state, order) {
        state.order = order
    },
    SET_AUTHOR: function (state, author) {
        state.author = author
    }
}

function eqSet(as, bs) {
    if (!as || !bs) return false
    if (as.size !== bs.size) return false;
    for (var a of as) if (!bs.has(a)) return false;
    return true;
}

const actions = {
    bindMoreQuestions: firestoreAction(async ({ bindFirestoreRef, state, commit, getters, dispatch }, { tags, order, author }) => {

        if (!tags || !eqSet(new Set(state.tags), new Set(tags)) || state.order != order || (state.author && state.author.pseudo != author)) {
            commit("RESET_QUESTIONS");
            if (tags && tags.length > 0)
                commit("SET_TAGS", tags);
            else
                commit("SET_TAGS", []);

            if (order)
                commit("SET_ORDER", order);
            else
                commit("SET_ORDER", "score");

            if ((!state.authorPseudo && author) || author != state.author.displayName) {
                let authorUid = await dispatch("social/searchUser", author, { root: true })
                if (authorUid)
                    commit("SET_AUTHOR", { id: authorUid, pseudo: author });
                else
                    commit("SET_AUTHOR", false);
            }
            else
                commit("SET_AUTHOR", false);

        }

        let ref = db.collection("questions")

        if (state.tags.length > 0)
            ref = ref.where("tags", "array-contains-any", state.tags);

        if (state.author)
            ref = ref.where("author", "==", state.author.id);

        if (order != "createdTime")
            ref = ref.orderBy(state.order, "desc");
        ref = ref.orderBy("createdTime", "desc");

        let numberOfQuestions = getters.getQuestions.length;
        if (numberOfQuestions > 0) {
            let lastQuestion = getters.getQuestions[numberOfQuestions - 1];
            if (order && order != "createdTime")
                ref = ref.startAfter(lastQuestion[order], lastQuestion.createdTime)
            else
                ref = ref.startAfter(lastQuestion.createdTime)
        }

        await bindFirestoreRef('questions.' + Object.values(state.questions).length, ref.limit(PAGE_SIZE));
        commit("REFRESH_QUESTIONS");
    }),
    bindMyQuestions: firestoreAction(async ({ bindFirestoreRef, rootState }) => {
        await bindFirestoreRef('myQuestions', db.collection("questions").where("author", "==", rootState.db.user.id).orderBy("createdTime", "desc"));
    }),
    addQuestion: async function ({ rootState, dispatch }, { question, tags }) {
        let id = await db.collection("questions").add({
            question,
            tags,
            createdTime: Date.now(),
            author: rootState.db.user.id,
            voteUp: 0,
            voteDown: 0,
            score: 0,
            used: 0
        })
        dispatch("globalRecommendations/addTags", tags, { root: true });
        ga.event("Questions", "create", id);
        return id;
    },
    deleteQuestion: async function ({ rootState, dispatch }, question) {
        if (question.author !== rootState.db.user.id)
            return false;

        let votes = await db.collection("questions").doc(question.id).collection("votes").get();
        await Promise.all(votes.docs.map(async doc => {
            await db.collection("questions").doc(question.id).collection("votes").doc(doc.id).delete();
        }))

        await db.collection("questions").doc(question.id).delete();
        dispatch("globalRecommendations/removeTags", question.tags, { root: true });
        ga.event("Questions", "delete", question.id);
    },
    vote: async function ({ rootState }, { question, vote }) {
        let previousVote = await db.collection("questions").doc(question.id).collection("votes").doc(rootState.db.user.id).get();
        let previousVoteVal = 0;
        if (previousVote.exists) {
            previousVoteVal = previousVote.data().vote;
            if (previousVote == vote)
                return;
        }
        let voteWrite = db.collection("questions").doc(question.id).collection("votes").doc(rootState.db.user.id).set({
            vote,
            updatedTime: Date.now(),
        })
        let scoreChange = vote - previousVoteVal;
        let voteUp = previousVoteVal == 1 ? -1 : 0;
        let voteDown = previousVoteVal == -1 ? -1 : 0;
        if (vote == 1) voteUp += 1;
        if (vote == -1) voteDown += 1;

        let questionWrite = db.collection("questions").doc(question.id).update({
            score: increment(scoreChange),
            voteUp: increment(voteUp),
            voteDown: increment(voteDown),
        })
        await Promise.all([voteWrite, questionWrite]);
    },
    use: async function ({ rootState }, question) {
        let voteWrite = db.collection("questions").doc(question.id).collection("votes").doc(rootState.db.user.id).set({
            used: increment(1),
            updatedTime: Date.now(),
        })
        let questionWrite = db.collection("questions").doc(question.id).update({
            used: increment(1),
        })
        await Promise.all([voteWrite, questionWrite]);
        ga.event("Questions", "use", question.id);
    },
    find: async function ({ state, getters }, id) {
        let search = getters.getQuestions.find(q => q.id === id);
        if (search) return search;

        search = state.myQuestions.find(q => q.id === id);
        if (search) return search;

        let doc = await db.collection("questions").doc(id).get();
        return doc.data();
    }
}
const getters = {
    getQuestions: state => Object.values(state.questions).flat(),
    hasMoreToLoad: (state, getters) => {
        if(getters.getQuestions.length % PAGE_SIZE != 0) return false;
        let list = Object.values(state.questions);
        if(list[list.length - 1].length == 0) return false;
        return true;
    }
}

export default {
    state,
    mutations,
    actions,
    getters
}